import type { Template } from "../types/template";
import { ApiError, apiRequest } from "./apiClient";

type BackendTemplateListItem = {
  readonly id: string;
  readonly template_name?: string | null;
  readonly template_type?: string | null;
  readonly business_units?: string[] | null;
  readonly created_by_name?: string | null;
  readonly created_at?: string | null;
};

type BackendTemplatesListResponse = {
  readonly data: BackendTemplateListItem[];
  readonly meta?: unknown;
};

type BackendTemplateDetail = {
  readonly id: string;
  readonly template_name?: string | null;
  readonly template_type?: string | null;
  readonly business_units?: string[] | null;
  readonly created_by_name?: string | null;
  readonly created_at?: string | null;
};

type BackendTemplateDetailResponse = {
  readonly data: BackendTemplateDetail;
};

const mapItemToTemplate = (item: BackendTemplateListItem | BackendTemplateDetail): Template => ({
  id: item.id,
  name:
    item.template_name && item.template_name.trim().length > 0 ? item.template_name : "Untitled Template",
  templateType: item.template_type ?? "",
  businessUnits: item.business_units ?? [],
  createdByName: item.created_by_name ?? null,
  createdAt: item.created_at ?? null
});

export const listTemplates = async (): Promise<Template[]> => {
  const response = await apiRequest("/templates?status=Active");
  const json = (await response.json()) as BackendTemplatesListResponse;
  if (!Array.isArray(json.data)) {
    return [];
  }

  return json.data.map(mapItemToTemplate);
};

export const getTemplateById = async (id: string): Promise<Template | null> => {
  let response: Response;
  try {
    response = await apiRequest(`/templates/${id}`);
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return null;
    throw err;
  }

  const json = (await response.json()) as BackendTemplateDetailResponse;
  if (!json.data) return null;

  return mapItemToTemplate(json.data);
};
